module.exports = __webpack_public_path__ + "img/video_sdk.687da058.svg";